import React from 'react';

import Skeleton from '@smart-tv/components/skeleton';

import styles from '../program-sheet.module.scss';

export const ProgramSheetSkeleton = () => {
  return (
    <div className={styles['program-sheet-skeleton']} aria-label="Indlæser produktblad">
      <div className={styles['program-sheet-skeleton__header']}>
        <Skeleton
          animation="wave"
          className={styles['program-sheet-skeleton__header-skeleton']}
          variant="rect"
        />
      </div>
      <div className={styles['program-sheet-skeleton__content']}>
        <div className={styles['program-sheet-skeleton__actions']}>
          <Skeleton
            animation="wave"
            className={styles['program-sheet-skeleton__action-label']}
            variant="rect"
          />
          <Skeleton
            animation="wave"
            className={styles['program-sheet-skeleton__action-button']}
            variant="rect"
          />
          <div className={styles['program-sheet-skeleton__secondary-actions']}>
            <Skeleton
              animation="wave"
              className={styles['program-sheet-skeleton__secondary-action']}
              variant="circle"
            />
            <Skeleton
              animation="wave"
              className={styles['program-sheet-skeleton__secondary-action']}
              variant="circle"
            />
          </div>
        </div>
        <div className={styles['program-sheet-skeleton__description']}>
          <Skeleton
            animation="wave"
            className={styles['program-sheet-skeleton__description-heading']}
            variant="rect"
          />
          <Skeleton
            animation="wave"
            className={styles['program-sheet-skeleton__description-line--full']}
          />
          <Skeleton
            animation="wave"
            className={styles['program-sheet-skeleton__description-line--wide']}
          />
          <Skeleton
            animation="wave"
            className={styles['program-sheet-skeleton__description-line--short']}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProgramSheetSkeleton);
